import { Button, useTheme } from "@mui/material";
import { Plus } from "lucide-react";
import type { FC } from "react";

type Props = {
	label: string;
	onClick: () => void;
	noBorder?: boolean;
};

export const PinInlineAction: FC<Props> = ({
	label,
	onClick,
	noBorder = false,
}) => {
	const theme = useTheme();

	return (
		<Button
			variant="inlineAction"
			startIcon={<Plus size={theme.iconSize.sm} />}
			onClick={onClick}
			sx={{
				borderTop: noBorder
					? "none"
					: theme.colors.border.solid(theme.palette.surface.border),
			}}
		>
			{label}
		</Button>
	);
};
